import type { SearchResultListItem, SearchResponseData } from '@/core/search/SearchProvider'

enum SearchResultFileType {
  UNKNOWN = 0,
  IMAGE = 1,
  AUDIO = 2,
  VIDEO = 3,
  DOCUMENT = 4,
  APK = 5,
  ARCHIVE = 6,
  FOLDER = 7,
}

export const OpenableFileList = [
  SearchResultFileType.IMAGE,
  SearchResultFileType.AUDIO,
  SearchResultFileType.VIDEO,
  SearchResultFileType.DOCUMENT,
]

export const handleSearchListsItem = (data: SearchResponseData) => {
  if (data.list.length === 0) return data

  data.list.map((item: SearchResultListItem) => {
    item.active = false
    const highlight = JSON.parse(item.highlight)

    if (highlight?.title) {
      const { content: filename, index: highlightArr } = highlight.title

      if (filename.length >= highlightArr[0].start) {
        let stashName = ''
        let stashIndex = 0

        for (const i of highlightArr) {
          stashName +=
            filename.slice(stashIndex, i.start) +
            '<span style="color:#2D40E9">' +
            filename.slice(i.start, i.end) +
            '</span>'
          stashIndex = i.end
        }
        item._filename = stashName + filename.slice(stashIndex)
      }
    }
  })

  return data
}
